module.exports = __webpack_public_path__ + "img/img03_mobile.28d1304a.png";